import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ActivityGroupRows } from "web_myplann/Activities/Components/ActivityGroupRows";
import { ActivityGroupVirtualRows } from "web_myplann/Activities/Components/ActivityGroupVirtualRows";
import { LoadNextRow } from "web_myplann/Activities/Components/LoadNextRow";
import {
	ACTIVITY_LIST_COLLAPSED_SIZE,
	ACTIVITY_LIST_VIRTUALIZATION_THRESHOLD,
} from "web_myplann/Activities/constants";
import type { ActivityGroup } from "web_myplann/Activities/Hooks/useActivityGroup";
import { ShowAllToggleButton } from "web_myplann/Shared/Components/ShowAllToggleButton";
import { useHistoryEntryToggle } from "web_myplann/Shared/Hooks/useHistoryEntryToggle";

type Props = {
	label: string;
	group: ActivityGroup;
	emptyText?: string;
};

export const ActivitiesListV2Group: FC<Props> = ({
	label,
	group,
	emptyText,
}) => {
	const [expanded, toggleExpanded] = useHistoryEntryToggle(label);
	const { items, totalCount, hasNextPage, isFetchingNextPage, fetchNextPage } =
		group;

	if (totalCount === 0 && !emptyText) {
		return null;
	}

	const visible = expanded
		? items
		: items.slice(0, ACTIVITY_LIST_COLLAPSED_SIZE);

	return (
		<Stack>
			<Typography variant="sectionLabel">{label}</Typography>
			<Stack bgcolor="background.paper">
				{totalCount === 0 ? (
					<Typography variant="body2" color="text.disabled" px={1.6} py={1.2}>
						{emptyText}
					</Typography>
				) : visible.length > ACTIVITY_LIST_VIRTUALIZATION_THRESHOLD ? (
					<ActivityGroupVirtualRows items={visible} />
				) : (
					<ActivityGroupRows items={visible} />
				)}

				{expanded && hasNextPage && (
					<LoadNextRow
						loading={isFetchingNextPage}
						onClick={() => fetchNextPage()}
					/>
				)}

				{totalCount > ACTIVITY_LIST_COLLAPSED_SIZE && (
					<ShowAllToggleButton expanded={expanded} onClick={toggleExpanded} />
				)}
			</Stack>
		</Stack>
	);
};
